module.exports = __webpack_public_path__ + "img/矩形 151@2x.7bec259d.png";